import Incidents from './Incidents';
import Solutions from './Solutions';
import Servicecases from './Servicecases';

export default {
  Incidents,
  Solutions,
  Servicecases
};
